import {Watcher} from "../../../api/Tasks2";
import {Checkbox, Chip, List, ListItemButton, ListItemText} from "@mui/material";
import {useContext, useEffect, useRef, useState} from "react";
import {ArrowDropDown} from "@mui/icons-material";
import {useAsync2, useAsyncAction} from "nate-react-api-helpers";
import {api} from "../../../api/API";
import NotificationsActiveIcon from '@mui/icons-material/NotificationsActive';
import {Task2CardContext} from "./Task2CardContext";
import {None} from "./None";
import {TaskPopover} from "./TaskPopover";

export function WatcherEdit(props: {
    value: Watcher[];
    task2: number;
}) {
    const [showEdit, setShowEdit] = useState(false);
    const anchorEl = useRef<HTMLDivElement|null>(null);
    const [list, setList] = useState<Watcher[]>(props.value);

    useEffect(() => {
        setList(props.value);
    }, [props.value]);

    const change = useAsyncAction(async (input) => {
        const result = await api.tasks2.updateWatchers(input);
        setList(result);
    }, []);

    const ctx = useContext(Task2CardContext);

    const closeEdit = () => {
        setShowEdit(false);
        ctx.reload();
    }

    return (
        <div>
            <div ref={anchorEl} style={{
                display: "flex",
                flexDirection: "row",
                gap: 4,
                alignItems: "center",
            }}>
                {list.map(itm => (
                    <Chip
                        icon={<NotificationsActiveIcon />}
                        size="small"
                        label={itm.usrName}
                        onClick={() => setShowEdit(true)}
                        onDelete={(e) => setShowEdit(true)}
                        deleteIcon={<ArrowDropDown />}
                    />
                ))}
                {list.length === 0 && <None onClick={() => {
                    setShowEdit(true);
                }}>
                    No Watchers
                </None>}
            </div>
            {showEdit && <TaskPopover title="Manage Watchers" anchorEl={anchorEl.current} onClose={() => closeEdit()}>
                <ChooseWatcher
                    value={list}
                    onChange={v => change.callback(v)}
                    task2={props.task2}
                />
            </TaskPopover>}
        </div>
    )
}

function ChooseWatcher(props: {
    task2: number;
    value: Watcher[];
    onChange(value: Watcher[]): void;
}) {
    const users = useAsync2(input => api.users.list(input), {offset: 0, search: ""}, []);

    return (
        <div>
            {users.LoadingOrErrorElement}
            <List dense>
            {users.result?.data.map(u => {
                const has = props.value.find(itm => itm.usr === u.id);

                return (
                    <ListItemButton onClick={() => {
                        if(has) {
                            props.onChange([Object.assign({}, has, {
                                archived: true,
                            })]);
                        } else {
                            props.onChange([{
                                id: 0,
                                task2: props.task2,
                                usr: u.id,
                                usrName: "",
                                archived: false,
                            }]);
                        }
                    }}>
                        <Checkbox checked={!!has}/>
                        <ListItemText primary={u.name} />
                    </ListItemButton>
                )
            })}
            </List>
        </div>
    )

}